/** Avatar y botón flotante de Sol (extraídos de GlobalRagChat sin cambios). */
import { cn } from '@/lib/utils';

// ────────────────────────────────────────────────────────────────────────────
// Avatar + FAB de Sol
// ────────────────────────────────────────────────────────────────────────────

/**
 * Avatar de Sol: círculo verde tipo WhatsApp con monograma "S" en
 * font display. Verde WhatsApp = #25D366 (HSL 142, 70%, 49%).
 * Gradiente sutil de claro a oscuro para profundidad.
 */
export function SolAvatar({ size = 'sm' }: { size?: 'sm' | 'lg' }) {
    const dim = size === 'lg' ? 'h-12 w-12' : 'h-7 w-7';
    const text = size === 'lg' ? 'text-display' : 'text-body';
    return (
        <div
            className={cn(
                'relative inline-flex items-center justify-center rounded-full',
                dim,
            )}
            aria-hidden
        >
            <span
                className={cn(
                    'absolute inset-0 rounded-full',
                    // WhatsApp green family: light teal-green → mid green → deep forest
                    'bg-[radial-gradient(circle_at_30%_30%,_hsl(142_85%_65%),_hsl(142_70%_49%)_55%,_hsl(150_75%_32%))]',
                    'shadow-[0_4px_18px_-4px_hsl(142_70%_49%_/_0.55),_inset_0_0_0_1px_hsl(0_0%_100%_/_0.18)]',
                )}
            />
            <span
                className={cn(
                    'relative font-semibold leading-none tracking-tight text-white',
                    text,
                )}
                style={{ fontFamily: '"SF Pro Display", system-ui, sans-serif' }}
            >
                S
            </span>
        </div>
    );
}

/**
 * Badge SVG "IA" pulsante para el FAB. Reemplaza el Sparkles genérico.
 * Forma: speech bubble redondeada con la letra "IA" centrada.
 * Animación: scale 1↔1.08 cada 2s para llamar la atención sutilmente.
 */
function IAMessageBadge() {
    return (
        <span
            className="absolute -right-1 -top-1 inline-flex h-5 w-5 items-center justify-center"
            aria-hidden
        >
            {/* SVG bubble + IA */}
            <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary-foreground relative h-full w-full drop-shadow"
            >
                {/* Bubble shape: rectángulo redondeado con tail abajo-derecha */}
                <path
                    d="M3 6.5C3 4.567 4.567 3 6.5 3h11C19.433 3 21 4.567 21 6.5v8c0 1.933-1.567 3.5-3.5 3.5H10l-4 3v-3H6.5C4.567 18 3 16.433 3 14.5v-8z"
                    className="fill-primary"
                />
                <text
                    x="12"
                    y="13.5"
                    textAnchor="middle"
                    className="font-bold"
                    style={{
                        fontFamily: '"SF Pro Display", system-ui, sans-serif',
                        fontSize: '8.5px',
                    }}
                    fill="currentColor"
                >
                    IA
                </text>
            </svg>
        </span>
    );
}

export function SolFab({ onClick, scopeLabel }: { onClick: () => void; scopeLabel: string }) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label="Abrir chat con Sol"
            title={`Sol · ${scopeLabel}`}
            className="group fixed bottom-4 right-4 z-30 print:hidden inline-flex items-center justify-center rounded-full transition-opacity hover:opacity-90 active:opacity-75 sm:bottom-5 sm:right-5"
        >
            <SolAvatar size="lg" />
            <IAMessageBadge />
        </button>
    );
}
